<template>
  <div class="container">
    <div v-if="partName"
         class="title">{{partName}}</div>
    <div class="row"
         v-for="(item, index) in list"
         :key="index"
         @click="clickPart(item.id)">
      <div>{{item.symptomName}}</div>
      <img src="@/assets/ic_go.png" />
    </div>
  </div>
</template>

<script>
import { partSymptomList } from '@/api/guidance'

export default {
  name: 'SymptomList',
  props: {
    partId: {
      type: String,
      default: null
    },
    partName: {
      type: String,
      default: null
    },
    sex: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.init()
  },
  watch: {
    partId() {
      this.init()
    }
  },
  methods: {
    init() {
      if (!this.partId) {
        return
      }
      partSymptomList({
        partsId: this.partId
      }).then(res => {
        if (res.success && res.code == 200) {
          this.list = res.result
        }
      })
    },
    getType() {
      if (this.sex == 1 && this.type == 0) {
        //男儿童
        return 2;
      } else if (this.sex == 2 && this.type == 0) {
        //女儿童
        return 4;
      } else if (this.sex == 2 && this.type == 1) {
        //女人
        return 3;
      } else {
        //男人
        return 1;
      }
    },
    clickPart(id) {
      this.$emit('clickSymptom', id)
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: white;
}

.title {
  text-align: center;
  padding: 10px 15px;
  color: #0063aa;
  background-color: white;
  border-bottom: 1px solid #f2f2f2;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 15px;
  background-color: white;
  border-bottom: 1px solid #f2f2f2;
}

.row div {
  flex: 1;
}

.row img {
  width: 6px;
  height: 10px;
}
</style>